import { HHSelect } from '@hinge-health/react-component-library';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { ScopeableType } from '../../../types';
import {
  PROGRAM_SCOPE_SELECT_TEST_ID,
  ScopeItem,
  SCOPE_PROGRAM_OPTIONS,
} from './scope-selector-constants';

export interface ProgramScopeSelectProps {
  disabled?: boolean;
  error?: FieldError;
}

export const ProgramScopeSelect = ({
  disabled,
  error,
}: ProgramScopeSelectProps): JSX.Element => {
  const { control } = useFormContext();
  const errorMessage = error?.message;

  const options = SCOPE_PROGRAM_OPTIONS.map(p => ({
    value: p.id.toString(),
    displayName: p.name,
  }));

  return (
    <Controller
      control={control}
      name="scopes"
      render={({ field: { onChange, value } }): JSX.Element => {
        const scopes: ScopeItem[] = (value as ScopeItem[]) ?? [];
        const current = scopes.find(
          s => s.scopeableType === ScopeableType.Program,
        );
        const initialValue = current?.scopeableId?.toString() ?? '';

        return (
          <HHSelect
            width={'100%'}
            label="Program"
            id="program-scope-select"
            data-testid={PROGRAM_SCOPE_SELECT_TEST_ID}
            disabled={disabled ?? false}
            initialSelectValue={initialValue}
            selectOptions={options}
            inputProps={{ 'aria-required': true }}
            error={!!errorMessage}
            helperText={errorMessage}
            fullWidth
            onChange={(e): void => {
              const raw = (e.target as HTMLInputElement).value;
              const id = parseInt(raw, 10);
              onChange(
                Number.isNaN(id)
                  ? []
                  : [
                      {
                        scopeableType: ScopeableType.Program,
                        scopeableId: id,
                      } as ScopeItem,
                    ],
              );
            }}
          />
        );
      }}
    />
  );
};
